const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaGranja: [], listaFornecedor: [], listaAnimal: [], listaItens: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'COMPRA_ANIMAL_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'COMPRA_ANIMAL_LISTADO':
            return { ...state, lista: action.payload.data };
		case 'COMPRA_ANIMAL_ITEM_LISTADO':
			return { ...state, listaItens: action.payload.data };
		case 'COMPRA_ANIMAL_GRANJA_SELECT_LISTADO':
            return { ...state, listaGranja: action.payload.data };
		case 'COMPRA_ANIMAL_CLIENTE_SELECT_LISTADO':
            return { ...state, listaFornecedor: action.payload.data };
		case 'COMPRA_ANIMAL_ANIMAL_SELECT_LISTADO':
            return { ...state, listaAnimal: action.payload.data };
		default:
            return state;
    }
}
